<form #form="ngForm" (keydown.enter)="$event.preventDefault()" *ngIf="!soloValores">
    <!-- PRINCIPIO ACTIVO -->
    <ng-container *ngFor="let sustancia of registro.valor.sustancias">
        <plex-select [(ngModel)]="sustancia.ingrediente" name="medicamento" (getData)="loadMedicamentoGenerico($event)"
                     label="Medicamento" idField="conceptId" labelField="term" (change)="valuesChange()"
                     required="true">
        </plex-select>
    </ng-container>

    <plex-grid cols="4">
        <plex-select [(ngModel)]="registro.valor.via" name="via" [data]="vias$ | async" span="3"
                     (change)="valuesChange()" label="Vía de administración" [preload]="true">
        </plex-select>
        <plex-int label="Cantidad" [(ngModel)]="registro.valor.cantidad" name="cantidad" required span="1">
        </plex-int>
    </plex-grid>
    <plex-text class="mb-2" *ngIf="afterInit" label="Preparación" [(ngModel)]="registro.valor.preparacion"
               name="indicaciones" [multiline]="true">
    </plex-text>

    <!-- FRECUENCIA -->
    <plex-title size="sm" titulo="Frecuencia">
        <div class="d-flex align-items-center">
            <plex-bool type="slide" name="boolSos" label="Indicación SOS" [(ngModel)]="registro.valor.sos"
                       [disabled]="registro.valor.unicaVez" (change)="onChangeSos($event)">
            </plex-bool>

            <plex-bool class="unicaVez" type="slide" name="boolUnicaVez" justify="start" label="Única Vez"
                       [(ngModel)]="registro.valor.unicaVez" [disabled]="registro.valor.sos"
                       (change)="onChangeUnicaVez($event)">
            </plex-bool>
        </div>
    </plex-title>

    <plex-text *ngIf="registro.valor.sos || registro.valor.unicaVez" label="Motivo" name="motivo"
               [(ngModel)]="registro.valor.motivo" [required]="registro.valor.sos || registro.valor.unicaVez">
    </plex-text>

    <div *ngIf="!registro.valor.sos">
        <plex-wrapper *ngFor="let frecuencia of registro.valor.frecuencias; let i = index">
            <plex-int label="Frecuencia" [(ngModel)]="frecuencia.frecuenciaValor" name="frecuenciaValor{{i}}"
                      [required]="!registro.valor.unicaVez && frecuencia.frecuenciaUnidad?.id !== 'otros'"
                      [disabled]="registro.valor.unicaVez || frecuencia.frecuenciaUnidad?.id === 'otros'"
                      [min]="frecuencia.min" [max]="frecuencia.max" span="1">
            </plex-int>
            <plex-select label="Unidad de tiempo" [(ngModel)]="frecuencia.frecuenciaUnidad" name="frecuenciaUnidad{{i}}"
                         [data]="unidadesFrecuencia" idField="id" labelField="nombre"
                         [required]="!registro.valor.unicaVez" (change)="onUnidadChange(frecuencia)">
            </plex-select>

            <plex-select *ngIf="frecuencia.frecuenciaUnidad?.id === 'otros'" label="Frecuencia especial"
                         [(ngModel)]="frecuencia.frecuenciaEspecial" name="frecuenciaEspecial{{i}}"
                         [data]="frecuenciasEspeciales" idField="id" labelField="nombre" span="2">
            </plex-select>
            <plex-grid cols="2">
                <plex-select label="Velocidad de Infusión: Unidad" [(ngModel)]="frecuencia.velocidadUnidad"
                             name="velocidadUnidad{{i}}" [data]="unidadesVelocidad" idField="id" labelField="nombre"
                             (change)="updateVelocidadFinal(frecuencia)" span="1">
                </plex-select>

                <plex-int label="Velocidad de Infusión: Valor" [(ngModel)]="frecuencia.velocidadValor"
                          name="velocidadValor{{i}}" span="1" min="0"
                          (ngModelChange)="updateVelocidadFinal(frecuencia)">
                </plex-int>

                <plex-text *ngIf="frecuencia.velocidadUnidad?.id === 'otro'" label="Especificar unidad"
                           [(ngModel)]="frecuencia.velocidadOtra" name="velocidadOtra{{i}}" span="2">
                </plex-text>
            </plex-grid>
            <plex-datetime type="time" name="hora" label="Horario de inicio" [(ngModel)]="frecuencia.horario"
                           [min]="fechaMin" [max]="fechaMax"
                           [disabled]="frecuencia.frecuencia && frecuencia.frecuencia.type !== 'number'" span="1">
            </plex-datetime>
        </plex-wrapper>
    </div>
    <plex-title size="sm" titulo="Aclaraciones y/o Comentarios"></plex-title>
    <div class="mr-3 mt-2">
        <plex-text *ngIf="afterInit" [html]="true" height="100" [(ngModel)]="registro.valor.indicaciones"
                   name="aclaraciones">
        </plex-text>
    </div>
</form>

<ng-container *ngIf="soloValores">
    <plex-grid cols="3" size="sm">
        <plex-label titulo="Medicamento" [subtitulo]="registro.valor.nombre || 'Sin especificar'">
        </plex-label>
        <plex-label *ngIf="registro.valor.via" titulo="Via de Administración"
                    [subtitulo]="registro.valor.via.term || 'Sin especificar'">
        </plex-label>

        <plex-label *ngIf="registro.valor.cantidad" titulo="Cantidad"
                    [subtitulo]="registro.valor.cantidad || 'Sin especificar'">
        </plex-label>

        <plex-label titulo="Preparación" *ngIf="registro.valor.preparacion" [subtitulo]="registro.valor.preparacion">
        </plex-label>
    </plex-grid>

    <plex-title size="sm" [titulo]="registro.valor.sos ? 'Frecuencia SOS' : 'Frecuencia'">
    </plex-title>

    <!-- Mostrar motivo solo si es SOS -->
    <plex-label *ngIf="registro.valor.sos && registro.valor.motivo" titulo="Motivo" [subtitulo]="registro.valor.motivo">
    </plex-label>

    <plex-grid cols="3" *ngFor="let frecuencia of registro.valor.frecuencias">

        <plex-label *ngIf="(frecuencia.frecuencia?.nombre || frecuencia.frecuenciaUnidad?.nombre !== 'Otros') &&
                    (frecuencia.frecuencia?.nombre || frecuencia.frecuenciaUnidad?.nombre || frecuencia.frecuenciaValor)"
                    titulo="Frecuencia" [subtitulo]="
                registro.valor.unicaVez
                    ? 'Única vez'
                    : (
                        (frecuencia.frecuenciaValor ? frecuencia.frecuenciaValor + ' ' : '') +
                        (frecuencia.frecuencia?.nombre || frecuencia.frecuenciaUnidad?.nombre || '')
                      )
            ">
        </plex-label>

        <plex-label *ngIf="!frecuencia.frecuencia?.nombre && frecuencia.frecuenciaEspecial?.nombre"
                    titulo="Frecuencia Especial" [subtitulo]="frecuencia.frecuenciaEspecial?.nombre">
        </plex-label>

        <plex-label titulo="Velocidad Infusión" [subtitulo]="frecuencia.velocidadFinal || 'Sin especificar'">
        </plex-label>
        <plex-label *ngIf="frecuencia.horario" titulo="Horario"
                    [subtitulo]="frecuencia.horario ? (frecuencia.horario | hora) : frecuencia.frecuencia?.nombre">
        </plex-label>
        <plex-label *ngIf="registro.valor.unicaVez && registro.valor.motivo" span="3" titulo="Motivo Única Vez"
                    [subtitulo]="registro.valor.motivo">
        </plex-label>

    </plex-grid>



    <div *ngIf="registro.valor.indicaciones" class="mt-3">
        <plex-label titulo="Aclaraciones y/o Comentarios">
        </plex-label>
        <div class="aclaraciones">
            <span [innerHTML]="registro.valor.indicaciones"></span>
        </div>
    </div>
</ng-container>